import axios from "axios";
import Config from "../../config/";
import moment from 'moment';
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;
const NEW_URL = "http://18.223.168.25:8080/kugiapi/";

export function cekAuth() {
  return {
    headers: {
      'Authorization': API_KEY + localStorage.getItem('token')
    }
  };
}

export function postLogin(datanya) {
    const url = `${ROOT_URL}users/login`;

    const request = axios.post(
      url, datanya ,cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}
